export * from './lib/sign-up.module';
